import { Component, Input } from '@angular/core';
import {
  Product,
} from 'apps/shared/src/models';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'lib-product-initial-monthly-payments-tooltip',
  templateUrl: 'product-initial-monthly-payment-tooltip.component.html',
  styleUrls: ['product-initial-monthly-payment-tooltip.component.scss'],
  standalone: true,
  imports: [
    NgbTooltip,
    CurrencyPipe,
  ],
})
export class ProductInitialMonthlyPaymentsTooltipComponent {
  @Input() public product: Product;
}
